import { render, staticRenderFns } from "./OrdersClosedList.vue?vue&type=template&id=620d0478&scoped=true"
import script from "./OrdersClosedList.vue?vue&type=script&lang=js"
export * from "./OrdersClosedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d0478",
  null
  
)

export default component.exports